<template>
  <div class="sku-selects">
    <div v-for="(props, code) in result.propsForCheck" v-if="SIZES && SIZES.length > 0">
      <div class="def-size">
        <div
          class="def-size__front"
          :class="{ 'def-size__front_active': open }"
          @click="open = !open"
        >
          <span class="def-size__face">
            <span class="def-size__title">{{ messages.size }}</span>
            <span>{{ getSelectedFace(props) }}</span>
          </span>
          <svg>
            <use xlink:href="#svg-arrow-down"></use>
          </svg>
        </div>

        <SlideUpDown :model-value="open" class="def-size__items">
          <PerfectScrollbar>
            <div
              v-for="res in props"
              class="def-size__item"
              :class="{
                'def-size__item_active': res.active,
                'def-size__item_disabled': res.disable,
              }"
              @click="
                getPageData({ url: res.detailPage, changeUrl: false });
                open = false;
              "
            >
              {{ res.displayValue }}
            </div>
          </PerfectScrollbar>
        </SlideUpDown>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import SlideUpDown from 'vue3-slide-up-down';
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';

export default {
  name: 'SkuSelect',
  components: {
    SlideUpDown,
    PerfectScrollbar,
  },
  props: {
    result: {
      type: [Object, Array],
    },
    changeData: {
      type: [Function, Object],
    },
  },
  data: function () {
    return {
      obData: this.result,
      api: '/ajax/', // @todo Временная мера, нужно будет нормально достать
      open: false,
    };
  },
  computed: {
    ...mapState({
      messages: ({ product }) => product.data.messages,
    }),
    SIZES() {
      return this.result.propsForCheck?.SIZES;
    },
  },
  methods: {
    ...mapActions({
      getPageData: 'product/getPageData',
    }),
    getSelectedFace(props) {
      let active = '';
      Object.keys(props).forEach((el) => {
        const element = props[el];
        if (element.active) {
          active = element.displayValue;
        }
      });
      return active;
    },
  },
  mounted() {
    if (App.debug) {
      console.log('Component: sku-select', this.obData);
    }
  },
};
</script>
<style lang="scss">
.sku-selects {
  margin-bottom: 32px;
}
.def-size {
  position: relative;
  font-weight: 500;
  font-size: rem(16);
  color: var(--text-colour-primary);
  &__front {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 56px;
    border: 1px solid #dfdfdf;
    padding-left: 16px;
    padding-right: 16px;
    &:hover {
      cursor: pointer;
    }
    svg {
      fill: black;
      width: 16px;
      height: 16px;
      transition: 0.2s linear transform;
    }
    &_active {
      svg {
        transform: rotate(180deg);
      }
    }
  }
  &__title {
    font-size: rem(14);
    color: #757575;
    margin-bottom: 4px;
    font-weight: 400;
  }
  &__face {
    display: flex;
    flex-direction: column;
  }
  &__items {
    border: 1px solid #dfdfdf;
    position: absolute;
    width: 100%;
    top: calc(100% - 1px);
    z-index: 2;
    background-color: #fff;
  }
  &__item {
    display: flex;
    align-items: center;
    height: 40px;
    padding-left: 16px;
    padding-right: 16px;
    transition: 0.2s linear background-color;
    &:hover {
      cursor: pointer;
      background-color: var(--background-colour-primary);
    }
    &_disabled {
      color: #757575;
      background-color: #d9d9d9;
    }
  }
  .ps {
    max-height: 290px;
    overflow-y: scroll;
  }
}
</style>
